const AppClient = {
  LOCAL_MAIN: 'LOCAL_MAIN',
  LOCAL_LITE: 'LOCAL_LITE',
  QA_MAIN: 'QA_MAIN',
  QA_LITE: 'QA_LITE',
  PREPROD_MAIN: 'PREPROD_MAIN',
  PREPROD_LITE: 'PREPROD_LITE',
  PROD_MAIN: 'PROD_MAIN',
  PROD_LITE: 'PROD_LITE',
  STAFFING_PROD: 'STAFFING_PROD',

  URL_LOCAL_MAIN: 'http://localhost:4200',
  URL_LOCAL_LITE: 'http://localhost:4200',
  URL_QA_MAIN: 'https://qa.iqigai.ai',
  URL_QA_LITE: 'https://qalite.iqigai.ai',
  URL_PREPROD_MAIN: 'https://preprod.iqigai.ai',
  URL_PREPROD_LITE: 'https://preprodlite.iqigai.ai',
  URL_PROD_MAIN: 'https://app.iqigai.ai',
  URL_PROD_LITE: 'https://applite.iqigai.ai',
  URL_STAFFING_PROD: 'https://fractal.iqigai.ai',

  // Base folder URLs for update checks (trailing slash required)
  // electron-updater fetches latest.yml from here; macOS banner constructs filename from here
  // LOCAL
  UPDATE_URL_LOCAL_WIN_MAIN:      'https://download.blaze360.ai/qa/win/main/',
  UPDATE_URL_LOCAL_WIN_LITE:      'https://download.blaze360.ai/qa/win/lite/',
  UPDATE_URL_LOCAL_MAC_MAIN:      'https://download.blaze360.ai/qa/mac/main/',
  UPDATE_URL_LOCAL_MAC_LITE:      'https://download.blaze360.ai/qa/mac/lite/',
  // QA
  UPDATE_URL_QA_WIN_MAIN:      'https://download.blaze360.ai/qa/win/main/',
  UPDATE_URL_QA_WIN_LITE:      'https://download.blaze360.ai/qa/win/lite/',
  UPDATE_URL_QA_MAC_MAIN:      'https://download.blaze360.ai/qa/mac/main/',
  UPDATE_URL_QA_MAC_LITE:      'https://download.blaze360.ai/qa/mac/lite/',
  // PREPROD
  UPDATE_URL_PREPROD_WIN_MAIN: 'https://download.blaze360.ai/preprod/win/main/',
  UPDATE_URL_PREPROD_WIN_LITE: 'https://download.blaze360.ai/preprod/win/lite/',
  UPDATE_URL_PREPROD_MAC_MAIN: 'https://download.blaze360.ai/preprod/mac/main/',
  UPDATE_URL_PREPROD_MAC_LITE: 'https://download.blaze360.ai/preprod/mac/lite/',
  // PROD
  UPDATE_URL_PROD_WIN_MAIN:    'https://download.blaze360.ai/app/win/main/',
  UPDATE_URL_PROD_WIN_LITE:    'https://download.blaze360.ai/app/win/lite/',
  UPDATE_URL_PROD_MAC_MAIN:    'https://download.blaze360.ai/app/mac/main/',
  UPDATE_URL_PROD_MAC_LITE:    'https://download.blaze360.ai/app/mac/lite/',

  // OPENOFFICE URL
  OPENOFFICE_URL_QA: "https://docs.iqigai.ai/"
};

module.exports = { AppClient };
